import type {CssBlock, CssRule} from './constants'

export const isCssRule = (block: CssBlock): block is CssRule => 'selector' in block
